import Vector from './Vector';

class Matrix {
  constructor(xBasis, yBasis) {
    this.xBasis = xBasis;
    this.yBasis = yBasis;
  }

  vectorProduct(vector, color=vector.color) {
    let newX = vector.x * this.xBasis.x + vector.y * this.yBasis.x;
    let newY = vector.x * this.xBasis.y + vector.y * this.yBasis.y;
    return new Vector([newX, newY], color);
  }

  inverse() {
    let det = this.det();
    if (Math.abs(det) < 0.0001) {det = 0.0001};
    let xBasis = new Vector([this.yBasis.y, -1*this.xBasis.y], null).scale(1/det);
    let yBasis = new Vector([-1*this.yBasis.x, this.xBasis.x], null).scale(1/det);
    return new Matrix(xBasis, yBasis);
  }

  det() {
    return this.xBasis.x * this.yBasis.y - this.yBasis.x * this.xBasis.y;
  }

  eigenvalues() {
    const a = this.xBasis.x;
    const b = this.yBasis.x;
    const c = this.xBasis.y;
    const d = this.yBasis.y;
    return this.quadform(1, -1*(a+d), (a*d-b*c));
  }

  quadform(a, b, c) {
    const x1 = -b + Math.sqrt(b*b - 4*a*c) / 2*a;
    const x2 = -b - Math.sqrt(b*b - 4*a*c) / 2*a;
    return {x1 , x2};
  }
}

export default Matrix;